export default __webpack_public_path__ + "static/hp-brand-deck-19-7c57323b0a00e61960462e88de545e2c.png";